
import { lazy, Suspense } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { ContentLayout } from "@/components/layout/ContentLayout";
import { DebugPanel } from "@/components/DebugPanel";

const DashboardContent = lazy(() => import("@/components/DashboardContent").then(m => ({ default: m.DashboardContent })));

const Index = () => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
      <div className="flex-1 flex flex-col">
        <DashboardHeader />
        <ContentLayout>
          <Suspense fallback={null}>
            <DashboardContent />
          </Suspense>
        </ContentLayout>
      </div>
      </div>
      <DebugPanel 
        layoutTemplate="dashboard" 
        pageName="Dashboard (Index)"
        customStyles={[
          { id: "welcome", label: "Welcome card", selector: "[data-welcome]", description: "User info display" },
          { id: "quick-links", label: "Quick links grid", selector: "[data-quick-links]", description: "Navigation shortcuts" },
          { id: "activity", label: "Recent activity", selector: "[data-activity]", description: "Activity feed sections" }
        ]}
      />
    </SidebarProvider>
  );
};

export default Index;
